//import { API, Helpers, Router } from '../Helpers';
import { NextArrow, PrevArrow, ReviewRating } from '../Shared';
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Slider from "react-slick";

export default class ReviewsCarousel extends Component {
    constructor(props) {
        super(props);

        this.state = {

        };
        
        this.findProductCoverPhoto = this.findProductCoverPhoto.bind(this);
        this.findReviewAvatar = this.findReviewAvatar.bind(this);
    }
    
    findProductCoverPhoto(tour)
    {
        if (!_.isEmpty(tour.cover_photo))
        {
            return tour.cover_photo.medium;
        }
        
        return '/images/placeholder-16-9.jpg';
    }
    
    findReviewAvatar(review)
    {
        if (!_.isEmpty(review.avatar))
        {
            return review.avatar;
        }
        
        return '/images/placeholder-avatar.jpeg';
    }
    
    showReview(review)
    {
        this.setState({
            review: review
        }, () => 
        {
            _$('#showReviewModal').modal('show');
        });
    }
        
    render() {
        
        const { reviews } = this.props.data;
        
        return (
            <div>
                {
                    !_.isEmpty(reviews.data) &&
                    <div>
                        <div className="row">
                        
                            <div className="col-12">
                                <Slider {...{
                                    className: "slick-carousel",
                                    infinite: true,
                                    initialSlide: 0,
                                    slidesToShow: 1,
                                    slidesToScroll: 1,
                                    prevArrow: <PrevArrow />,
                                    nextArrow: <NextArrow />,
                                    responsive: [
                                        {
                                            breakpoint: 1200,
                                            settings: {
                                                slidesToShow: 1,
                                                slidesToScroll: 1
                                            }
                                        },
                                        {
                                            breakpoint: 1024,
                                            settings: {
                                                arrows: false,
                                                centerMode: true,
                                                centerPadding: '20px',
                                                slidesToShow: 1,
                                                slidesToScroll: 1
                                            }
                                        },
                                        {
                                            breakpoint: 768,
                                            settings: {
                                                arrows: false,
                                                centerMode: true,
                                                centerPadding: '20px',
                                                slidesToShow: 1,
                                                slidesToScroll: 1
                                            }
                                        }
                                    ]
                                }}>

                                {
                                    reviews.data.map((review, key) => {
                                        
                                        const avatar = this.findReviewAvatar(review);
                                        const cover_photo = this.findProductCoverPhoto(review.tour);

                                        return (
                                            <div key={key} className="position-relative h-100">
                                                <div className="row no-gutters d-none d-lg-flex">
                                                    <div className="col-6 background-cover" style={{ backgroundImage: "url(" + cover_photo + ")", minHeight: '400px' }}>
                                                        <div className="p-3">
                                                            {
                                                                _.times(5, (key) => {

                                                                    return(
                                                                        <span key={key} className={(review.tour.average_rating >= key + 1 ? "fa" : "far") + " fa-star primary-text mr-1"}></span>
                                                                    )
                                                                })
                                                            }
                                                        </div>
                                                    </div>
                                                    <div className="col-6">
                                                        <div className="view grey lighten-3 p-5 h-100">
                                                            {
                                                                !_.isEmpty(review.tour.address) &&
                                                                <div><span className="font-smaller text-uppercase">{review.tour.address}</span></div>
                                                            }

                                                            <h4 className="body-font font-weight-bold mb-3">
                                                                {review.tour.name}
                                                            </h4>

                                                            <div className="media mb-2">
                                                                <div className="mr-2 align-self-center">
                                                                    <img className="avatar tiny-avatar border-3p border-white border-solid" src={avatar} />
                                                                </div>
                                                                <div className="media-body align-self-center">
                                                                    <div className="font-weight-bold">{review.author}</div>
                                                                </div>
                                                            </div>

                                                            <div>
                                                                {_.truncate(review.comment, {length: 200})}
                                                                            
                                                                {
                                                                    review.comment.length > 200 &&
                                                                    <div>
                                                                        <button 
                                                                            className="btn btn-link body-text-color font-weight-bold px-0"
                                                                            onClick={() => { this.showReview(review) }}>
                                                                            read more
                                                                        </button>
                                                                    </div>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                
                                                <div className="d-flex d-lg-none h-100">
                                                    <div className="card rounded-0 z-depth-0">
                                                        <div className="card-image overflow-hidden position-relative">
                                                            <img className="img-fluid" src={cover_photo} />

                                                            <div className="p-2 position-absolute" style={{ top: '0px', left: '0px' }}>
                                                                {
                                                                    _.times(5, (key) => {

                                                                        return(
                                                                            <span key={key} className={(review.tour.average_rating >= key + 1 ? "fa" : "far") + " fa-star primary-text mr-1"}></span>
                                                                        )
                                                                    })
                                                                }
                                                            </div>
                                                        </div>

                                                        <div className="card-body border-top-0 position-relative grey lighten-3">
                                                            {
                                                                !_.isEmpty(review.tour.address) &&
                                                                <div><span className="font-smaller text-uppercase truncate-1">{review.tour.address}</span></div>
                                                            }

                                                            <h4 className="three-b-text font-weight-bold body-font mb-3 truncate-2 d-none d-lg-webkit-box">
                                                                {review.tour.name}
                                                            </h4>

                                                            <h5 className="three-b-text font-weight-bold body-font mb-3 truncate-2 d-lg-none">
                                                                {review.tour.name}
                                                            </h5>

                                                            <div className="media mb-2">
                                                                <div className="mr-2 align-self-center">
                                                                    <img className="avatar tiny-avatar border-3p border-white border-solid" src={avatar} />
                                                                </div>
                                                                <div className="media-body align-self-center">
                                                                    <div className="font-weight-bold">{review.author}</div>
                                                                </div>
                                                            </div>

                                                            <div>
                                                                <div className="truncate-5">{_.truncate(review.comment, {length: 200})}</div>

                                                                {
                                                                    review.comment.length > 200 &&
                                                                    <div>
                                                                        <button 
                                                                            className="btn btn-link body-text-color font-weight-bold px-0"
                                                                            onClick={() => { this.showReview(review) }}>
                                                                            read more
                                                                        </button>
                                                                    </div>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                                </Slider>
                            </div>
                        </div>
                    </div>
                }
                
                <div id="showReviewModal" className="modal fade" tabIndex="-1" role="dialog" aria-hidden="true">
                    <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
                        {
                            !_.isEmpty(this.state.review) &&
                            <div className="modal-content">
                                <div className="modal-header border-bottom-0 p-4">
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body pt-0 px-4 px-lg-5 vh-50 overflow-y-auto">
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="media d-block d-lg-flex mb-4">
                                                <div className="mr-0 mr-lg-4 align-self-center">
                                                    <img className="img-fluid w-100" style={{ maxWidth: '150px' }} src={this.findProductCoverPhoto(this.state.review.tour)} />
                                                </div>
                                                <div className="media-body align-self-center">
                                                    <div>
                                                        {
                                                            !_.isEmpty(this.state.review.tour.address) &&
                                                            <div><span className="body-text-color font-smaller text-uppercase">{this.state.review.tour.address}</span></div>
                                                        }

                                                        <h4 className="body-font font-weight-bold">{this.state.review.tour.name}</h4>
                                                        <ReviewRating 
                                                            star_rating={this.state.review.tour.average_rating}
                                                            count={this.state.review.tour.reviews_count}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        
                                            <div className="mb-5">
                                                <div className="media mb-3">
                                                    <div className="mr-2 align-self-center">
                                                        <img className="avatar tiny-avatar border-3p border-white border-solid" src={this.findReviewAvatar(this.state.review)} />
                                                    </div>
                                                    <div className="media-body align-self-center">
                                                        <div className="font-weight-bold">{this.state.review.author}</div>
                                                    </div>
                                                </div>

                                                <div className="mb-3 mb-lg-4">
                                                    {this.state.review.comment}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        );
    }
}

if (document.getElementById('reviewsCarousel')) {
    
    const element = document.getElementById('reviewsCarousel');
    const data = Object.assign({}, element.dataset);
        
    // console.log(data.data);
    
    ReactDOM.render(<ReviewsCarousel data={JSON.parse(data.data)} />, document.getElementById('reviewsCarousel'));
}



// WEBPACK FOOTER //
// ./resources/js/components/Shortcodes/ReviewsCarousel.js